
import { BlurEvent, DataDisplayEvent, DataSourceValidationEvent, Layout, Textbox, ValidationResult } from "@mcleod/components";
import { AutogenLayoutCarrierScorecardProfileDetail } from "./autogen/AutogenLayoutCarrierScorecardProfileDetail";
import { CarrierScorecardUtil } from "./CarrierScorecardUtil";
import { FieldUpdateEvent, ModelRow } from "@mcleod/core";

export class CarrierScorecardProfileDetail extends AutogenLayoutCarrierScorecardProfileDetail {

    textboxPerfMetricOnDataDisplay(event: DataDisplayEvent) {
        CarrierScorecardUtil.configureLayoutForMetric(this)
    }

    sourceCarrierScorecardDetailAfterModeChange() {
        if (this.activeRow) {
            this.activeRow.addAfterFieldUpdateListener((event: FieldUpdateEvent) => {
                if (event.fieldName === "performance_metric" && event.newValue != event.oldValue) {
                    CarrierScorecardUtil.configureLayoutForMetric(this);
                }
            });
        }
    }

    sourceCarrierScorecardDetailOnValidate(event: DataSourceValidationEvent) {
        const result = this.validateMetricFields(event.row);
        if (result) {
            event.validationResults.push(result);
        }
    }

    public validateMetricFields(row: ModelRow): ValidationResult {
        const metric = row.getString("performance_metric");
        switch (metric) {
            case "CHKCALLS":
                return this.validateCheckCall(row);
            case "ONTIME":
                return this.validateOnTime(row);
            default:
                return null;
        }
    }

    private validateOnTime(row: ModelRow<any>): ValidationResult {
        if (!row.getBoolean("include_shipper_stops", false)
            && !row.getBoolean("include_consignee_stops", false)
            && !row.getBoolean("include_extra_stops", false)) {
            const message = "At least one stop type - shipper, consignee, extra stops - must be selected";
            return {
                isValid: false,
                validationMessage: message,
                caption: message,
                component: this.panelMetricFields
            };
        }
        return null;
    }

    private validateCheckCall(row: ModelRow): ValidationResult {
        if (!row.getBoolean("incld_carr_initiated_calls", false)
            && !row.getBoolean("incld_brokerinitiated_calls", false)) {
            const message = "At least one initated type - broker or carrier - must be selected";
            return {
                isValid: false,
                validationMessage: message,
                caption: message,
                component: this.panelMetricFields
            };
        }
        return null;
    }
}
